import { APIError } from '@/plugins/api/error'
import { IconSlug } from '@/v2/components/ui/icon/iconMap'
import EventEmitter from 'eventemitter3'

export type AlertAction = {
  text: string
  fn: () => void
}
export type Alert = {
  message?: string | null
  description?: string | null
  action?: AlertAction
  icon?: IconSlug
}
export type AlertWithError = Alert & { error?: APIError | Error | unknown }

export type AppEvents = {
  'alert:ok': [Alert]
  'alert:info': [Alert]
  'alert:warn': [Alert]
  'alert:error': [AlertWithError]
  'sideMenu:close': []
}

export const eventBus = new EventEmitter<AppEvents>()
